import { useState } from "react";
import MainLayout from "../../components/layout/layout";
import { LabelText, LargeHeadline } from "../../components/typography";
import Input from "../../components/ui/inputs";
import { BodyBlock } from "./sign-in";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import toast from "react-hot-toast";
import { useAuthValidation } from "../../assets/utils/hooks/useAuthValidation";
import { AuthModeEnum } from "../../assets/utils/validation/types";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_URL_AUTH } from "../../constants";
import { store } from "../../assets/store";
import { clearResetEmail } from "../../assets/store/reset-password";
import { clearConfirmCode } from "../../assets/store/confirm-code";

export default function ResetPassword() {
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const [loaderState, setLoaderState] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errors, validate } = useAuthValidation();

  async function reset() {
    try {
      setLoaderState(true);

      const { hasErrors } = validate(
        { password, confirmPassword },
        AuthModeEnum.RESET
      );
      if (hasErrors) return;

      const response = await fetch(`${API_URL_AUTH}/verify-reset-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: store.getState().resetPassword.email,
          code: store.getState().confirmCode.code,
          password: password, 
          confirmPassword: confirmPassword,
        }),
        credentials: "include",
      });

      if (!response.ok) {
        const text = await response.text();
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.ERROR}
            text={
              text.split("\n")[0].split("System.Exception:")[1]?.trim() ||
              "Помилка вводу"
            }
          />
        ));
        return;
      }

      toast((t) => (
          <CustomToast
            t={t}
            type={
              response.status === 200
                ? ToastTypeEnum.SUCCESS
                : ToastTypeEnum.ERROR
            }
            text={
              response.status === 200
                ? "Пароль успішно змінено."
                : "Помилка у оновленні паролю."
            }
          />
        ));

      dispatch(clearResetEmail());
      dispatch(clearConfirmCode());
      navigate("/sign-in");
    } catch (error) {
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.ERROR}
          text={"Упс, щось пішло не так"}
        />
      ));
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 1000);
    }
  }

  return (
    <MainLayout
      className="d-flex flex-column align-items-center"
      loaderState={loaderState}
    >
      <BodyBlock>
        <LargeHeadline>Оновити пароль</LargeHeadline>
        <Input
          attribute="password"
          value={password}
          setValue={setPassword}
          errorText={errors?.password}
          label="Пароль"
          placeholder="Введіть новий пароль"
        />
        <Input
          attribute="passwordConfirm"
          value={confirmPassword}
          setValue={setConfirmPassword}
          errorText={errors?.confirmPassword}
          label="Підтвердіть пароль"
          placeholder="Введіть пароль"
        />
        <Button
          bgcolor={COLORS.blue}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          width="100%"
          type="large"
          className="mt-3"
          onClick={reset}
        >
          <LabelText>Оновити</LabelText>
        </Button>
      </BodyBlock>
    </MainLayout>
  );
}
